module.exports = __webpack_public_path__ + "static/media/puff-doble-rojo.05217fd6.png";